export default __webpack_public_path__ + "static/media/exit_button.74c0ac6b.svg";